/* global bsBreakpoints */

const sliderHome = () => {
	// VARIABLES

	const root = document.querySelector('.slider-container');
	const wrapper = root.querySelector('.custom-slider');
	const slides = wrapper.querySelectorAll('.custom-slider__slide') || null;
	const pagination = root.querySelector('.nav__pagination');
	const navButtons = root.querySelectorAll('[data-btn]');
	const navigation = root.querySelector('.custom-slider__nav');
	const prevBtn = navigation.querySelector('.nav__arrows__prev');
	const nextBtn = navigation.querySelector('.nav__arrows__next');
	const endSlider = root.querySelector('[data-end-slider]');
	let bsBreakpoint = bsBreakpoints.detectBreakpoint();

	// FUNCTIONS

	/**
	 * @description Set le premier slide active
	 * @constructor
	 */

	const initFirstSlide = (el, options) => {
		if (el !== undefined) {
			Object.keys(options).forEach(function (attr) {
				el.setAttribute(attr, options[attr]);
			});
		}
	};

	/**
	 * @description A11Y du slider
	 * @param slider {number}
	 * @param thisSlide {number}
	 * @constructor
	 */
	const A11Y = () => {
		slides.forEach((item) => {
			if (item.classList.contains('slide-active')) {
				item.querySelector('a').focus();
			} else {
				item.tabIndex = -1;
			}
		});
		document.querySelectorAll('[tabindex="0"] a').forEach((link) => {
			link.tabIndex = 0;
		});

		document.querySelectorAll('[tabindex="-1"] a').forEach((link) => {
			link.tabIndex = -1;
		});
	};
	/**
	 * @description Return le nombre de slide présent dans le slider
	 * @returns {number}
	 * @constructor
	 */
	const nbSlides = () => {
		return slides.length;
	};

	/**
	 * @description Return la data-slide  du slide actif
	 * @returns {number}
	 * @constructor
	 */
	const currentSlide = () => {
		let current;
		slides.forEach((slide) => {
			if (slide.classList.contains('slide-active')) {
				current = slide.getAttribute('data-slide');
			}
		});
		return current;
	};
	/**
	 * @description Fonction pour skip le slider
	 * @param slider {number}
	 */
	const skipSlider = () => {
		root.querySelector('[data-skip-slider]').addEventListener(
			'click',
			() => {
				endSlider.style.visibility = 'inherit';
				endSlider.focus();
			}
		);
	};
	/**
	 * @description reset les slides / dot actifs
	 */
	const cleanSlideActive = () => {
		const dots = document.querySelectorAll('.nav__pagination__dot');
		slides.forEach((slide) => {
			if (slide.classList.contains('slide-active')) {
				slide.classList.remove('slide-active');
			}
		});
		dots.forEach((dot) => {
			if (dot.classList.contains('dot-active')) {
				dot.classList.remove('dot-active');
			}
		});
	};
	/**
	 * @description Ecoute les fleches du clavier et déclenche le click sur btn prev/next
	 */
	const keyListener = () => {
		let click = 0;
		window.addEventListener('keydown', (e) => {
			const dots = document.querySelectorAll('.nav__pagination__dot');
			dots.forEach((dot) => {
				if (dot.classList.contains('dot-active')) {
					click = dot.getAttribute('data-id');
				}
			});
			if (e.key === 'ArrowRight') {
				if (click < nbSlides()) {
					click++;
					nextBtn.click();
				}
			} else if (e.key === 'ArrowLeft') {
				click--;
				if (click >= 1) {
					prevBtn.click();
				} else {
					click = 0;
				}
			}
		});
	};
	/**
	 * @description click dot dot
	 */
	const dotDot = () => {
		const dots = document.querySelectorAll('.nav__pagination__dot');
		dots.forEach((dot, index) => {
			dot.addEventListener('click', () => {
				btnVisibility(index + 1);
				if (
					bsBreakpoint === 'medium' ||
					bsBreakpoint === 'large' ||
					bsBreakpoint === 'xLarge'
				) {
					cleanSlideActive();
					const dotId = dot.getAttribute('data-id');
					slides[dotId - 1].classList.add('slide-active');
					dot.classList.add('dot-active');
					dot.setAttribute('aria-current', 'true');
					A11Y();
				}
			});
		});
	};
	/**
	 * @description Création des dot dot
	 * @constructor
	 */
	const paginate = () => {
		pagination.innerHTML = '';
		for (let i = 0; i < nbSlides(); i++) {
			slides[i].setAttribute('data-slide', i + 1);
			if (
				bsBreakpoint === 'medium' ||
				bsBreakpoint === 'large' ||
				bsBreakpoint === 'xLarge'
			) {
				if (i === 0) {
					pagination.innerHTML +=
						'<button aria-current="true" aria-describedby="hpActuMixte" type="button" class="nav__pagination__dot dot-active" data-id="' +
						(i + 1) +
						'"><span class="sr-only">' +
						(i + 1) +
						'</span></button>';
				} else {
					pagination.innerHTML +=
						'<button aria-describedby="hpActuMixte" type="button" class="nav__pagination__dot" data-id="' +
						(i + 1) +
						'"><span class="sr-only">' +
						(i + 1) +
						'</span></button>';
				}
			}
		}
		if (bsBreakpoint === 'xSmall' || bsBreakpoint === 'small') {
			pagination.innerHTML +=
				'<span class="nav__pagination__dot">' +
				currentSlide() +
				'/' +
				nbSlides() +
				'</span>';
		}
	};
	/**
	 * @description Affiche/cache les btn prev//next
	 * @param current {number}
	 */
	const btnVisibility = (current) => {
		if (current === 1) {
			prevBtn.classList.add('arrow-disabled');
			nextBtn.classList.remove('arrow-disabled');
			prevBtn.setAttribute('tabIndex', '-1');
			nextBtn.setAttribute('tabIndex', '0');
			nextBtn.focus();
		} else if (current === nbSlides()) {
			prevBtn.classList.remove('arrow-disabled');
			nextBtn.classList.add('arrow-disabled');
			nextBtn.setAttribute('tabIndex', '-1');
			prevBtn.setAttribute('tabIndex', '0');
			prevBtn.focus();
		} else {
			prevBtn.classList.remove('arrow-disabled');
			nextBtn.classList.remove('arrow-disabled');
			nextBtn.setAttribute('tabIndex', '0');
			prevBtn.setAttribute('tabIndex', '0');
		}
	};
	/**
	 * @description Gestion des btn
	 * @param btnAction {string}
	 * @param increment number}
	 * @param btnVisibility function}
	 */
	const nav = () => {
		if (nbSlides() === 1) {
			navigation.classList.add('nav-hidden');
		}
		navButtons.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				let increment = currentSlide();
				const btnAction = btn.getAttribute('data-btn');
				const dots = document.querySelectorAll('.nav__pagination__dot');
				cleanSlideActive();

				// A11Y: Delete aria-current="true"
				dots.forEach((dot) => {
					if (dot.getAttribute('aria-current') === 'true') {
						dot.removeAttribute('aria-current');
					}
				});

				if (btnAction === 'next' && increment < nbSlides()) {
					slides[increment].classList.add('slide-active');
					if (
						bsBreakpoint === 'medium' ||
						bsBreakpoint === 'large' ||
						bsBreakpoint === 'xLarge'
					) {
						dots[increment].classList.add('dot-active');
						dots[increment].setAttribute('aria-current', 'true');
					} else {
						pagination.innerHTML =
							'<span class="nav__pagination__dot">' +
							currentSlide() +
							'/' +
							nbSlides() +
							'</span>';
					}
					increment++;
				} else if (btnAction === 'prev') {
					increment--;
					slides[increment - 1].classList.add('slide-active');
					if (
						bsBreakpoint === 'medium' ||
						bsBreakpoint === 'large' ||
						bsBreakpoint === 'xLarge'
					) {
						dots[increment - 1].classList.add('dot-active');
						dots[increment - 1].setAttribute(
							'aria-current',
							'true'
						);
					} else {
						document.querySelector(
							'.nav__pagination__dot'
						).innerHTML = '' + increment + ' / ' + nbSlides() + '';
					}
				}
				btnVisibility(increment);
				A11Y();
				setTimeout(() => {
					wrapper.querySelector('.slide-active a').focus();
				}, 400);
			});
		});
	};

	// init first slide{
	initFirstSlide(slides[0], {
		class: 'custom-slider__slide slide-active',
	});

	A11Y();
	keyListener();
	paginate();
	dotDot();
	nav();
	btnVisibility(1);
	skipSlider();
	window.addEventListener('resize', () => {
		bsBreakpoint = bsBreakpoints.getCurrentBreakpoint();
		paginate();
		dotDot();
	});
};
const generateSlider = () => {
	sliderHome();
};
generateSlider();
